import { Classes, ResizeSensor } from '@blueprintjs/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

const Scroller = styled.div`
  overflow: auto;
  ${({ height, isEnabled }) => isEnabled && `height: ${height}px;`}
  border-radius: 3px;
`;

const AutoScroller = ({ children, className, height }) => {
  const [isScrollEnabled, setScrollEnabled] = useState(false);

  const handleResize = useCallback(
    ([entry]) => setScrollEnabled(entry.contentRect.height > height),
    [height],
  );

  return (
    <Scroller
      className={classNames(className, Classes.ELEVATION_0)}
      height={height}
      isEnabled={isScrollEnabled}
    >
      <ResizeSensor onResize={handleResize}>{children}</ResizeSensor>
    </Scroller>
  );
};

AutoScroller.defaultProps = {
  children: undefined,
  className: undefined,
  height: 400,
};

AutoScroller.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  height: PropTypes.number,
};

export default AutoScroller;
